import { Notebook } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const NotebookIcon = createLucideIcon(Notebook);
